














































































import Vue from 'vue';
import ModelOperation from '@/utils/modelOperation';
import UserInfo from '@/components/UserInfo.vue';
import * as api from '@/api';
import LockModalTip from '../../components/lock-modal-tips.vue';

export default Vue.extend({
    components: {
        UserInfo, LockModalTip,
    },
    data() {
        return {
            loading: true,
            lockedIsVisable: false,
            // 这个字段自己定义
            input: '',
            active: '',
            modelOperation: {},
            bench: null,
            groupIds: [
                ['VawM5+SRlkeqhOb+72kfFQEA'],
                ['iHgaowB4yEy2yHUIGjlZZQEA'],
                ['6rEqg25fYkiBm3AjA7fdJgEA'],
                ['6rEqg25fYkiBm3AjA7ghnQEA'],
                ['6rEqg25fYkiBm3AjA7g/JwEA'],
                ['6rEqg25fYkiBm3AjA7gGFgEA'],
                ['6rEqg25fYkiBm3AjA7gAHQEA'],
                ['pGsk7CqBeEKE3NuL06gsMQEA'],
                ['wvyh2eefrEqjhbIDJu15PAEA'],
                ['wvyh2eefrEqjhbIDJu1gXQEA'],
            ],
            items: [
                {
                    id: 0, groupName: '双开门', name: '建筑', subscript: 'Architecture', isLocked: true, icon: require('../../assets/images/home/home_icon_jianzhu_nor.png'), activeIcon: require('../../assets/images/home/home_icon_jianzhu_sel.png'),
                },
                {
                    id: 1, groupName: '圆形柱_混凝土', name: '结构', subscript: 'Structural', isLocked: true, icon: require('../../assets/images/home/home_icon_jiegou_nor.png'), activeIcon: require('../../assets/images/home/home_icon_jiegou_sel.png'),
                },
                {
                    // Plumbing
                    id: 2, groupName: '生活水泵', name: '给排水', subscript: 'Water system', isLocked: true, icon: require('../../assets/images/home/home_icon_geipaishui_nor.png'), activeIcon: require('../../assets/images/home/home_icon_geipaishui_sel.png'),
                },
                {
                    id: 3, groupName: '分体空调', name: '暖通', subscript: 'HVAC', isLocked: true, icon: require('../../assets/images/home/home_icon_nuantong_nor.png'), activeIcon: require('../../assets/images/home/home_icon_nuantong_sel.png'),
                },
                {
                    id: 4, groupName: '配电箱', name: '电气', subscript: 'Electrical', isLocked: true, icon: require('../../assets/images/home/home_icon_dianqi_nor.png'), activeIcon: require('../../assets/images/home/home_icon_dianqi_sel.png'),
                },
                {
                    id: 5, groupName: '水泵接合器', name: '市政', subscript: 'Civil Engineering', isLocked: true, icon: require('../../assets/images/home/home_icon_shizheng_nor.png'), activeIcon: require('../../assets/images/home/home_icon_shizheng_sel.png'),
                },
                {
                    id: 6, groupName: '景观灯', name: '园林', subscript: 'Landscape ', isLocked: true, icon: require('../../assets/images/home/home_icon_yuanlin_nor.png'), activeIcon: require('../../assets/images/home/home_icon_yuanlin_sel.png'),
                },
                {
                    id: 7, groupName: '扬尘监测仪', name: '施工', subscript: 'Construction', isLocked: true, icon: require('../../assets/images/home/home_icon_shigong_nor.png'), activeIcon: require('../../assets/images/home/home_icon_shigong_sel.png'),
                },
                {
                    id: 8, groupName: '干挂石材', name: '装饰', subscript: 'Decoration', isLocked: true, icon: require('../../assets/images/home/home_icon_zhuangshi_nor.png'), activeIcon: require('../../assets/images/home/home_icon_zhuangshi_sel.png'),
                },
                {
                    id: 9, groupName: '预制柱', name: '装配式', subscript: 'Fabrication', isLocked: true, icon: require('../../assets/images/home/home_icon_qita_nor.png'), activeIcon: require('../../assets/images/home/home_icon_qita_sel.png'),
                },
            ],
            model: {
                modelGroupId: 'spdv28f05443d0e9d05478891f2f8a087b86',
                modelPath: 'SpiderView/ee053579-e824-4a1a-8b69-3f101cb543b1/00000000-0000-0000-0000-000000000000/f4767fe3c70f06e83f4d156a7233ef78/9/',
            },
            infos: [
                [{ Name: '元素编码', Value: '14-10.20.09(门)' }, { Name: '产品编码', Value: '30-13.10.35.25(防火门)' }, { Name: '宽度', Value: '1500mm' }, { Name: '高度', Value: '2100mm' }, { Name: '功能分类', Value: '常开防火门' }, { Name: '耐火极限', Value: '甲级' }],
                [{ Name: '元素编码', Value: '14-20.20.09(混凝土柱)' }, { Name: '产品编码', Value: '30-01.15.00(商品混凝土)' }, { Name: '材质', Value: '商品混凝土' }, { Name: '强度等级', Value: 'C30' }, { Name: '抗渗等级', Value: 'P6' }, { Name: '直径', Value: '400mm' }, { Name: '全部纵筋', Value: '8C22' }, { Name: '箍筋', Value: 'C10@100/200' }],
                [{ Name: '元素编码', Value: '14-30.20.15(水泵)' }, { Name: '产品编码', Value: '30-31.15.10(给水泵)' }, { Name: '型号', Value: 'CDL32-40' }, { Name: '流量', Value: '5.5m3/h' }, { Name: '扬程', Value: '31m' }, { Name: '功率', Value: '7.5kw' }],
                [{ Name: '元素编码', Value: '14-30.30.03(空调机组)' }, { Name: '产品编码', Value: '30-44.00.00(空调)' }, { Name: '型号', Value: 'SRFNC50D' }, { Name: '制冷面积', Value: '20-35㎡' }, { Name: '制热面积', Value: '25-34㎡' }, { Name: '制冷量', Value: '5000W' }, { Name: '制冷功率', Value: '1550W' }, { Name: '制热量', Value: '5500W' },
                { Name: '制热功率', Value: '1660W' }, { Name: '尺寸', Value: '1715mmx492mmx278mm' }],
                [{ Name: '元素编码', Value: '30-50.20.20.10(动力配电箱)' }, { Name: '型号', Value: 'AP12' }, { Name: '深度', Value: '600mm' }, { Name: '宽度', Value: '800mm' }, { Name: '高度', Value: '2200mm' }],
                [{ Name: '产品编码', Value: '30-30.10.10.30(消防水泵接合器)' }, { Name: '主体材质', Value: '灰铸铁-涂漆' }, { Name: '工作压力', Value: '1600000pa' }, { Name: '流量', Value: '10l/s' }, { Name: '公称直径', Value: '150mm' }, { Name: '系统类型', Value: '室外消防系统' }],
                [{ Name: '元素编码', Value: '14-10.30.09(灯具)' }, { Name: '产品编码', Value: '30-51.20.20.13(庭院灯)' }, { Name: '功率', Value: '15w' }, { Name: '光源数量', Value: '1' }, { Name: '光源类型', Value: 'LED' }, { Name: '管径类型', Value: 'T5' },
                { Name: '光通量', Value: '待定' }, { Name: '防护等级', Value: 'IP43' }, { Name: '安装方式', Value: '杆吊式' }],
                [{ Name: '供电', Value: '220V' }, { Name: '通信接口', Value: 'GPRS网络' }, { Name: '温度传感器', Value: '-40~120℃；0.1℃；±0.5℃' }, { Name: '湿度传感器', Value: '0~10%RH；0.1%RH；±4.%RH' }, { Name: '风速传感器', Value: '0~30m/s；0.1m/s；±5%' }, { Name: '风向传感器', Value: '16个方位' }, { Name: '噪声传感器', Value: '30~120db；0.1db；±0.5db' }, { Name: 'PM2.5', Value: '0~500ug/m³；0.1ug/m³；±10%' }, { Name: 'PM10', Value: '0~500ug/m³；0.1ug/m³；±10%' }],
                [{ Name: '元素编码', Value: '14-10.20.21.12(石材幕墙)' }, { Name: '产品编码', Value: '30-13.20.15(石材幕墙)' }, { Name: '材质', Value: '大理石' }, { Name: '宽度', Value: '600mm' }, { Name: '高度', Value: '600mm' }, { Name: '厚度', Value: '20mm' }],
                [{ Name: '产品编码', Value: '30-01.10.10(预制混凝土柱)' }, { Name: '砼等级', Value: 'C30' }, { Name: '安装高度', Value: '0m' }, { Name: '灌浆料类型', Value: 'CGM-1通用型' }, { Name: '灌浆料等级', Value: 'C30' }, { Name: '截面宽度', Value: '150mm' }, { Name: '截面高度', Value: '150mm' }],
            ],
        };
    },
    mounted() {
        this.getproductTypes();
        const file = {
            size: 122,
        };
        this.modelOperation = new ModelOperation(file, this.model.modelGroupId);
        setTimeout(() => {
            this.open3D();
        }, 20);
    },
    computed: {
        user(): boolean {
            return this.$store.state.user;
        },
        clickGroupIds() {
            return this.$store.state.clickGroupIds;
        },
        modelLoadComplete() {
            return this.$store.state.modelLoadComplete;
        },
    },
    watch: {
        clickGroupIds(val) {
            if (val.length === 0) {
                this.active = '';
            }
        },
        active(id) {
            (this.modelOperation as any).clearGroup(this.bench);
            (this.modelOperation as any).chooseHighlight(this.bench, this.groupIds[id], this.infos[id], this.items[id].groupName); // 高亮构件
        },
    },
    methods: {
        async toUserCenter() {
            const isLoginRes = await api.isLogined();
            if (!api.error(isLoginRes)) {
                this.$router.push({ path: '/user' });
            } else {
                this.login();
            }
        },
        login() {
            this.$store.commit('loginVisible', true);
        },
        search(keyword) {
            if (keyword) {
                // this.$router.push({
                //     path: '/search-results',
                //     query: {
                //         keyword,
                //         type: this.active,
                //     },
                // });
                this.$router.push({
                    path: '/home-work',
                });
            } else {
                this.$router.push({
                    path: '/home-work',
                });
            }
        },
        select(id, isLocked) {
            this.active = id;
            if (isLocked === true) {
                // this.$message.warning('请先解锁');
                this.lockedIsVisable = true;
            } else {
                     (this.modelOperation as any).destroy(this.bench);
                     this.$router.push('/products');
            }
        },
        async open3D() {
            this.bench = (this.modelOperation as any).createBench(this.model, this, 'home_model');
        },
       async getproductTypes() {
            const res = await api.getMyParentProductTypes();
            if (!api.error(res)) {
               this.items.forEach((x) => {
                   res.data.forEach((y) => {
                       if (x.name === y.name) {
                           x.isLocked = false;
                       }
                   });
               });
            }
        },
    },
    destroyed() {
        (this.modelOperation as any).destroy(this.bench);
    },
});
